import React from 'react';
import toast from 'react-hot-toast';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';

// Small icon button that copies a value to the clipboard and shows a toast.
// Replaces the ~8 duplicated inline copy SVGs in the old CaseReview component.
export default function CopyButton({ value, label, className = '' }) {
    const handleCopy = (e) => {
        e.stopPropagation();
        if (value === undefined || value === null) return;
        navigator.clipboard.writeText(value.toString()).then(
            () => toast.success(label ? `Copied ${label}` : 'Copied'),
            () => toast.error('Failed to copy')
        );
    };

    return (
        <button
            type="button"
            onClick={handleCopy}
            title={label ? `Copy ${label}` : 'Copy to clipboard'}
            className={`text-gray-500 hover:text-blue-600 p-1 flex-shrink-0 ${className}`}
        >
            <ClipboardDocumentIcon className="h-5 w-5" />
        </button>
    );
}
